// extracted by mini-css-extract-plugin
export var base = "Logo-module--base--18d93";
export var fullHeight = "Logo-module--full-height--9fd81";
export var fullWidth = "Logo-module--full-width--02a83";